@if (isCollapsed) {
  <!-- Version collapsed: Badge avec icône centré -->
  @if (discoveryStatus()) {
    <div class="flex items-center justify-center">
      <button
        class="relative flex h-14 w-12 cursor-pointer items-center justify-center rounded-lg bg-transparent transition-all duration-300 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:ring-offset-2"
        [pTooltip]="'discovery.upgrade' | transloco"
        tooltipPosition="right"
        [tooltipOptions]="{ showDelay: 300, hideDelay: 200 }"
        (click)="handleClick()"
        (keydown.enter)="handleClick()"
        (keydown.space)="handleClick()"
        [attr.aria-label]="'discovery.upgrade' | transloco"
        type="button"
        pRipple
      >
        <!-- Icône Discovery avec badge en dessous -->
        <div class="flex flex-col items-center justify-center gap-0.5">
          <lucide-icon
            name="flask-conical"
            [size]="24"
            class="text-greyscale-500 transition-colors duration-300 ease-out"
          >
          </lucide-icon>

          <!-- Badge compteur en dessous -->
          <div
            class="animate-pulse rounded border border-primary-200 bg-primary-100 px-1.5 py-0.5 text-xs font-medium leading-none text-primary-700"
            [class.animate-bounce]="isLimitReached"
            [class.!bg-warning-100]="isLimitReached"
            [class.!border-warning-200]="isLimitReached"
            [class.!text-warning-700]="isLimitReached"
            style="font-size: 10px"
          >
            {{ displayCount }}
          </div>
        </div>
      </button>
    </div>
  }
} @else {
  <!-- Version expanded: Réutiliser le composant original -->
  <app-discovery-progress></app-discovery-progress>
}
